import { Add } from '@mui/icons-material';
import { MenuItem, TextField } from '@mui/material';
import { AnimatePresence } from 'framer-motion';
import { useState } from 'react';

import { nextSprintDates } from '@/tracker/entities/sprint';
import { CreateSprintRequest, Sprint } from '@/tracker/types';

import { SprintDialog } from '../SprintDialog';
import { ALL_TASKS, SprintFilter } from '../../model/BoardStore';

import s from './SprintFilterSelect.module.scss';

const CREATE_SPRINT = 'create';

type Props = {
  value: SprintFilter;
  /** Незавершённые спринты доски */
  sprints: Sprint[];
  /** Создавать спринты могут владелец доски и админ */
  canCreate: boolean;
  isSaving: boolean;
  onChange: (value: SprintFilter) => void;
  /** true — создан, диалог закрывается */
  onCreate: (data: CreateSprintRequest) => Promise<boolean>;
};

/** Выбор спринта над доской; последним пунктом — «Создать спринт», как в Яндекс Трекере */
const SprintFilterSelect: React.FC<Props> = ({
  value,
  sprints,
  canCreate,
  isSaving,
  onChange,
  onCreate,
}) => {
  const [isCreating, setIsCreating] = useState(false);

  return (
    <>
      <TextField
        select
        size="small"
        sx={{ width: 240 }}
        value={value}
        onChange={(event) => {
          // «Создать спринт» — действие, а не значение фильтра
          if (event.target.value === CREATE_SPRINT) {
            setIsCreating(true);

            return;
          }

          onChange(event.target.value);
        }}
        slotProps={{ select: { SelectDisplayProps: { 'aria-label': 'Спринт' } } }}
      >
        {sprints.map((sprint) => (
          <MenuItem key={sprint.id} value={sprint.id}>
            {sprint.name}
            {sprint.status === 'active' && ' · идёт'}
          </MenuItem>
        ))}
        <MenuItem value={ALL_TASKS}>Все задачи доски</MenuItem>
        {canCreate && (
          <MenuItem value={CREATE_SPRINT} className={s.create}>
            <Add fontSize="small" sx={{ mr: 1 }} />
            Создать спринт
          </MenuItem>
        )}
      </TextField>

      <AnimatePresence>
        {isCreating && (
          <SprintDialog
            initial={{ name: '', ...nextSprintDates(sprints) }}
            isEdit={false}
            isSaving={isSaving}
            onSubmit={onCreate}
            onClose={() => setIsCreating(false)}
          />
        )}
      </AnimatePresence>
    </>
  );
};

export { SprintFilterSelect };
